export var reloadedThemes;
(function (reloadedThemes) {
    /** @deprecated */
    reloadedThemes["reloaded_horizon_light"] = "reloaded_horizon_light";
    /** @deprecated */
    reloadedThemes["reloaded_horizon_alternative"] = "reloaded_horizon_alternative";
    /** @deprecated */
    reloadedThemes["reloaded_modelbank_light"] = "reloaded_modelbank_light";
    /** @deprecated */
    reloadedThemes["reloaded_modelbank_alternative"] = "reloaded_modelbank_alternative";
    /** @deprecated */
    reloadedThemes["reloaded_nova_alternative"] = "reloaded_nova_alternative";
    /** @deprecated */
    reloadedThemes["reloaded_nova_light"] = "reloaded_nova_light";
    /** @deprecated */
    reloadedThemes["flame_private_light_alt"] = "flame_private_light_alt";
    /** @deprecated */
    reloadedThemes["flame_retail_light_alt"] = "flame_retail_light_alt";
    /** @deprecated */
    reloadedThemes["flame_select_light_alt"] = "flame_select_light_alt";
    /** @deprecated */
    reloadedThemes["flame_retail_light_wealth_alt"] = "flame_retail_light_wealth_alt";
    reloadedThemes["horizon_light_regular"] = "horizon_light_regular";
    reloadedThemes["horizon_light_alternative"] = "horizon_light_alternative";
    reloadedThemes["horizon_light_inverse"] = "horizon_light_inverse";
    reloadedThemes["modelbank_light_regular"] = "modelbank_light_regular";
    reloadedThemes["modelbank_light_alternative"] = "modelbank_light_alternative";
    reloadedThemes["nova_light_alternative"] = "nova_light_alternative";
    reloadedThemes["nova_light_regular"] = "nova_light_regular";
    reloadedThemes["flame_private_light_alternative"] = "flame_private_light_alternative";
    reloadedThemes["flame_private_light_inverse"] = "flame_private_light_inverse";
    reloadedThemes["flame_private_light_regular"] = "flame_private_light_regular";
    reloadedThemes["flame_retail_light_alternative"] = "flame_retail_light_alternative";
    reloadedThemes["flame_retail_light_inverse"] = "flame_retail_light_inverse";
    reloadedThemes["flame_select_light_alternative"] = "flame_select_light_alternative";
    reloadedThemes["flame_select_light_inverse"] = "flame_select_light_inverse";
    reloadedThemes["flame_select_light_regular"] = "flame_select_light_regular";
    reloadedThemes["flame_retail_light_regular"] = "flame_retail_light_regular";
    reloadedThemes["flame_retail_light_wealth_regular"] = "flame_retail_light_wealth_regular";
    reloadedThemes["flame_retail_light_wealth_alternative"] = "flame_retail_light_wealth_alternative";
    reloadedThemes["cobranded_light_alternative"] = "cobranded_light_alternative";
    reloadedThemes["cobranded_light_regular"] = "cobranded_light_regular";
    reloadedThemes["bnpl_light_alternative"] = "bnpl_light_alternative";
    reloadedThemes["bnpl_light_regular"] = "bnpl_light_regular";
})(reloadedThemes || (reloadedThemes = {}));
//# sourceMappingURL=reloadedProvider.js.map